import { useGetSimpleUpdateData } from '@cp-shared-19/frontend-integration';
import { InvoiceDeliveryNotification } from '@cp-mx/common';
import { updateInvoiceDeliveryNotifications } from './InvoiceDeliveryNotificationsSlice';
import { InvoiceDeliveryNotificationsSelector } from './InvoiceDeliveryNotificationsSelector';

type UpdateInvoiceDeliveryNotifications = {
    updateInvoiceDeliveryNotifications: (data: InvoiceDeliveryNotification[]) => void;
    invoiceDeliveryNotifications: InvoiceDeliveryNotification[];
};

export const useUpdateInvoiceDeliveryNotifications = (): UpdateInvoiceDeliveryNotifications => {
    const {
        updateData,
        dataState: { data },
    } = useGetSimpleUpdateData(updateInvoiceDeliveryNotifications, InvoiceDeliveryNotificationsSelector);

    return {
        updateInvoiceDeliveryNotifications: updateData,
        invoiceDeliveryNotifications: data as InvoiceDeliveryNotification[],
    };
};
